export const getSidebarByRole = (sidebar, adminInfo) => {
    const role = parseInt(adminInfo?.role, 10);
    const nextSidebar = role === 0 ? sidebar.filter((item) => ['대시보드', '데이터'].includes(item.mainTitle)) : sidebar;

    return nextSidebar
        .filter((section) => !section.blur)
        .map((section) => ({
            ...section,
            subTitleList: section.subTitleList.filter((sub) => !sub.blur),
        }));
};
